export const emailPattern = /\S+@\S+\.\S+/;
